import React from 'react';


const NotyHistoriaTHead = () => {
    return (
        <thead>
            <tr>
                <th>
                    Id noty
                </th>
                <th>
                    Mieszkaniec
                </th>
                <th>
                    Mieszkanie
                </th>
                <th>
                    Miesiąc
                </th>
                <th>
                    Podgląd
                </th>
                <th>
                    Nazwa pliku
                </th>
                <th> E-mail</th>
            </tr>
        </thead>
    )
}

export default NotyHistoriaTHead;